import React, { useState } from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_dashboard-index.scss';
import { RangeDatePicker, DatePicker } from "@y0c/react-datepicker";
import { Button, Modal } from 'react-bootstrap';
import LineChart1 from '../../components/charts/Chartjs/line1'

const DashBoard = () => {


    const [modalCentered, setModalCentered] = useState(false);
    const [pathState, setPathState] = useState("");
    const handleClose = () => setModalCentered(false)



    return (
        <div className='dashBoard'>

            <PageTitle title="Dashboard" />

            <div className="row m-0  mt-4">
                <div className="col-md-8 col-lg-8">
                    <div className="row d-flex left-banner-section align-items-center">
                        <div className="col-md-8 col-lg-8">
                            <h2 style={{ color:'white' }}>Welcome to <br /> Foodhub</h2>
                        </div>
                        <div className="col-md-4 col-lg-4 text-right banner-img pr-0">

                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-lg-4">
                    <div className="row d-flex right-banner-section align-items-center ml-2">
                        <div className="col-md-8 col-lg-8">
                            <h4 style={{ color: 'white' }}>Get Started! </h4>
                            <small className='mt-2'>Check out foodpanda University to know more </small>
                        </div>
                        <div className="col-md-4 col-lg-4 text-right right-banner-img pr-0">

                        </div>
                    </div>
                </div>
            </div>

            <div className="row m-0">
                <div className="col-md-8 col-lg-8 p-0">
                    <div className="card rounded-0 banner-down">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-7 col-lg-7">
                                    <small> 3 simple steps to get Greeno Juice Bars. Askari 4 started! When all are completed,please return to the welcome email to go live! </small>
                                </div>
                                <div className="col-md-5 col-lg-5">
                                    <div className="d-grid">
                                        <label htmlFor="">Select vendor</label>
                                        {/* <select name="" id="">
                                            <option value="">Green Juice Bars - Askari 4 (s6dm)</option>
                                        </select> */}
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-1 menu d-flex align-items-center">
                                <div className="col-md-10 col-lg-10 d-flex">
                                    <input type="checkbox" disabled />
                                    <ul className='ml-3'>
                                        <li className='d-grid'>
                                            <b>Menu</b>
                                            <span className='menu-title'>Lorem sum.Lorem sum Lorem sum</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-2 col-lg-2">
                                    <i className='mdi mdi-chevron-right fs-3'> </i>
                                </div>
                            </div>
                            <div className="row mt-4 menu d-flex align-items-center">
                                <div className="col-md-10 col-lg-10 d-flex ">
                                    <input type="checkbox" disabled />
                                    <ul className='ml-3'>
                                        <li className='d-grid'>
                                            <b>Opening Time</b>
                                            <span className='menu-title'>Lorem sum.Lorem sum Lorem sum</span>
                                        </li>
                                    </ul>

                                </div>
                                <div className="col-md-2 col-lg-2 ">
                                    <i className='mdi mdi-chevron-right fs-3'> </i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row m-0 notification">
                <span>Notification</span>
                <div className=" mt-1 py-0 notifiation-card">
                    <div className="row content">
                        <div className="col-md-1 col-lg-1">
                            <i className='mdi mdi-bell fs-4' style={{ color: 'green' }} > </i>
                        </div>
                        <div className="col-md-11 col-lg-11 pl-0">
                            <h6>Firstly device check in then work</h6>
                            <small> morning 15 mintued lorem sum lorem sum lorem sum morning 15 mintued lorem sum lorem sum lorem sum  </small>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row m-0 mt-5 performance">
                <div className="card w-100">
                    <div className="card-body">
                        <b className='fs-4'>Performance Indicators</b>
                        <div className="row mt-3">
                            <div className="col-md-4 col-lg-4">
                                <small>Average Preparation Time</small>
                                <div className="d-flex">
                                    <b className='fs-2'>11 mins</b>
                                    <span className='badge badge-danger light ml-2'>10%</span>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <small>Order Rejection Rate</small>
                                <div className="d-flex">
                                    <b className='fs-2'>1.09%</b>
                                    <span className='badge badge-success light ml-2'>64.84%</span>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <small>Customer Conversion Rate</small>
                                <div className="d-flex">
                                    <b className='fs-2'>24.6%</b>
                                    <span className='badge badge-success light ml-2'>95.24%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row m-0">
                <div className="col-md-4 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <i className='mdi mdi-receipt fs-2' style={{ color: '#43738f' }}> </i>
                                <div className="d-grid ml-3">
                                    <span className='fs-2'>19</span>
                                    <small>Orders Today</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <i className='mdi mdi-close-circle fs-2' style={{ color: '#43738f' }}> </i>
                                <div className="d-grid ml-3">
                                    <span className='fs-2'>19</span>
                                    <small>Cancelled Orders Today</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <i className='mdi mdi-lock-outline fs-2' style={{ color: '#43738f' }}> </i>
                                <div className="d-grid ml-3">
                                    <span className='fs-2'>19</span>
                                    <small>Offline restaurants now</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row m-0 mt-5 d-flex align-items-center">
                <div className="col-md-6 col-lg-6">
                    <span>Business Summery</span>
                </div>
                <div className="col-md-6 col-lg-6 justify-content-end d-flex align-items-center">
                    <div className="form-check form-switch d-flex align-items-center">
                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" style={{ width: "3em" }} />
                        <label className="form-check-label ps-2" htmlFor="flexSwitchCheckDefault">Compare</label>
                    </div>
                    <div className='ml-3'>
                        <ul>
                            <li className='mt-1'>
                                <div className="d-flex flex-row timeframe">
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="today" />
                                        <label className="form-check-label" htmlFor='today'>
                                            Today
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="yesterday" />
                                        <label className="form-check-label" htmlFor='yesterday'>
                                            Yesterday
                                        </label>
                                    </div>
                                    <div onClick={() => setModalCentered(true)} className='border-left d-flex justify-content-center align-items-center'>
                                        <i className="bi bi-three-dots-vertical px-2 fw-bold" style={{ cursor: 'pointer' }}></i>
                                    </div>
                                </div>

                                <Modal className="fade" centered onHide={handleClose} show={modalCentered}>

                                    <Modal.Body>
                                        <h5>Date selector</h5>
                                        <p>
                                            Select a custom time frame
                                        </p>

                                        <RangeDatePicker
                                            startText="Start"
                                            endText="End"
                                            startPlaceholder="Start Date"
                                            endPlaceholder="End Date"
                                        />
                                    </Modal.Body>
                                    <div className='d-flex justify-content-end p-4'>
                                        <Button variant="info" className="me-3">Cancel</Button>
                                        <Button variant="primary">Apply</Button>
                                    </div>
                                </Modal>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>

            <div className="row m-0 mt-2">
                <div className="col-md-6 col-lg-6">
                    <div className="card rounded-0">
                        <div className="card-header d-block">
                            <div className="d-flex">
                                <b>Orders</b>
                                <i className='mdi mdi-information-outline ml-1'> </i>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6 col-lg-6">
                                    <div className="d-grid">
                                        <small>Total</small>
                                        <span className='fs-2'>530</span>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="d-grid">
                                        <small>Cancelled</small>
                                        <span className='fs-2'>530</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            <LineChart1 />
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6">
                    <div className="card rounded-0">
                        <div className="card-header d-block">
                            <div className="d-flex">
                                <b>Revenue</b>
                                <i className='mdi mdi-information-outline ml-1'> </i>
                            </div>
                            <div className="d-grid mt-3">
                                <small>Total</small>
                                <span className='fs-2'> PKR 334,295.00</span>
                            </div>
                        </div>
                        <div className='card-body'>
                            <LineChart1 />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default DashBoard;